import { graphql } from 'gql';

export const getAgreementsRegistry = graphql(`
    query uerContractChanges(
        $contractId: Long!
        $where: ContractChangeItemDataFilterInput
        $skip: Int
        $take: Int
        $order: [ContractChangeItemDataSortInput!]
    ) {
        uerContractChanges(contractId: $contractId, where: $where, skip: $skip, take: $take, order: $order) {
            items {
                id
                status
                subject
                signingDate
                internalNumber
                createdAt
                uerRowCount
                mtrRowCount
                ratioRowCount
            }
            totalCount
        }
    }
`);

export const getContractChangeSubjectFilter = graphql(`
    query uerContractChangeSubjectFilter($contractId: Long!, $where: FilterValueOfStringFilterInput) {
        uerContractChangeSubjectFilter(contractId: $contractId, where: $where) {
            items {
                value
            }
        }
    }
`);

export const getContractChangeInternalNumberFilter = graphql(`
    query uerContractChangeInternalNumberFilter($contractId: Long!, $where: FilterValueOfStringFilterInput) {
        uerContractChangeInternalNumberFilter(contractId: $contractId, where: $where) {
            items {
                value
            }
        }
    }
`);

export const getChangeSigningDateFilter = graphql(`
    query uerContractChangeSigningDateFilter($contractId: Long!, $where: FilterValueOfNullableOfDateTimeFilterInput) {
        uerContractChangeSigningDateFilter(contractId: $contractId, where: $where) {
            items {
                value
            }
        }
    }
`);

export const getChangeCreatedAtFilter = graphql(`
    query uerContractChangeCreatedAtFilter($contractId: Long!, $where: FilterValueOfDateTimeFilterInput) {
        uerContractChangeCreatedAtFilter(contractId: $contractId, where: $where) {
            items {
                value
            }
        }
    }
`);

export const getContractChangeStatusFilter = graphql(`
    query uerContractChangeStatusFilter(
        $contractId: Long!
        $where: FilterValueOfNullableOfContractChangeStatusEnumFilterInput
    ) {
        uerContractChangeStatusFilter(contractId: $contractId, where: $where) {
            items {
                value
            }
        }
    }
`);

export const createAgreement = graphql(`
    mutation uerCreateContractChange($input: ContractChangeInput!) {
        uerCreateContractChange(input: $input) {
            data {
                id
            }
            buttonText
            hasValidation
            hideValidation
            validation {
                property
                message
            }
            result
            message
        }
    }
`);

export const updateAgreement = graphql(`
    mutation uerUpdateContractChange($contractChangeInput: ContractChangeUpdateInput!) {
        uerUpdateContractChange(contractChangeInput: $contractChangeInput) {
            data {
                id
                status
            }
            result
            message
            buttonText
            hasValidation
            hideValidation
            validation {
                property
                message
            }
        }
    }
`);

export const getAgreement = graphql(`
    query uerContractChange($contractChangeId: Long!) {
        uerContractChange(contractChangeId: $contractChangeId) {
            data {
                id
                contractId
                status
                statusFollowers
                subject
                signingDate
                internalNumber
                createdAt
                uerRowCount
                mtrRowCount
                otherRowCount
                ratioRowCount
                authoredBy
                statusFollowers
            }
            result
            message
            buttonText
            hasValidation
            hideValidation
            validation {
                property
                message
            }
        }
    }
`);

export const deleteAgreement = graphql(`
    mutation uerDeleteContractChange($contractChangeId: Long!) {
        uerDeleteContractChange(contractChangeId: $contractChangeId) {
            id
            result
            message
            buttonText
            hasValidation
            hideValidation
            validation {
                property
                message
            }
        }
    }
`);

export const checkIsUniqueInternalNumber = graphql(`
    query uerIsUniqueContractChangeInternalNumber($contractChangeId: Long, $number: String!, $contractId: Long!) {
        uerIsUniqueContractChangeInternalNumber(
            contractChangeId: $contractChangeId
            number: $number
            contractId: $contractId
        ) {
            result
            message
            buttonText
            hasValidation
            hideValidation
            validation {
                property
                message
            }
        }
    }
`);

export const getAgreementPriceListMtr = graphql(`
    query uerContractChangePriceListMtr(
        $contractChangeId: Long!
        $take: Int
        $skip: Int
        $where: PriceListMtrRowDataFilterInput
    ) {
        uerContractChangePriceListMtr(contractChangeId: $contractChangeId, take: $take, skip: $skip, where: $where) {
            items {
                id
                contractId
                code
                name
                unit
                volume
                unitWeight
                unitCost
                supplyBy
                supplyBasis
                mtrType
                pricingType
                note
                status
                isIncludedInWorkOrder
                isIncludedInAct
                isIncludedInWorkOrderChange
                justification
                mtrSupplyAndType
                hasDuplicateNeighbours
            }
            totalCount
        }
    }
`);

export const addMtrToContractChange = graphql(`
    mutation uerAddMtrsToContractChange($contractChangeId: Long!, $mtrRowIds: [Long!]!) {
        uerAddMtrsToContractChange(contractChangeId: $contractChangeId, mtrRowIds: $mtrRowIds) {
            data
            result
            message
            buttonText
            hasValidation
            hideValidation
            validation {
                property
                message
            }
        }
    }
`);

export const getAgreementMtrForIncluding = graphql(`
    query uerPriceListMtrForIncludingToContractChange(
        $contractChangeId: Long!
        $take: Int
        $skip: Int
        $where: PriceListMtrRowDataFilterInput
    ) {
        uerPriceListMtrForIncludingToContractChange(
            contractChangeId: $contractChangeId
            take: $take
            skip: $skip
            where: $where
        ) {
            totalCount
            items {
                mtrType
                id
                pricingType
                note
                status
                isIncludedInWorkOrder
                isIncludedInAct
                isIncludedInWorkOrderChange
                justification
                mtrSupplyAndType
                hasDuplicateNeighbours
                contractId
                code
                name
                unit
                volume
                unitWeight
                unitCost
                supplyBy
                supplyBasis
            }
        }
    }
`);

export const getAgreementMtrCodeFilterItems = graphql(`
    query uerContractChangeMtrCodeFilter($contractChangeId: Long!, $where: FilterValueOfStringFilterInput) {
        uerContractChangeMtrCodeFilter(contractChangeId: $contractChangeId, where: $where) {
            items {
                value
            }
        }
    }
`);

export const getAgreementMtrNameFilterItems = graphql(`
    query uerContractChangeMtrNameFilter($contractChangeId: Long!, $where: FilterValueOfStringFilterInput) {
        uerContractChangeMtrNameFilter(contractChangeId: $contractChangeId, where: $where) {
            items {
                value
            }
        }
    }
`);

export const getAgreementMtrUnitFilterItems = graphql(`
    query uerContractChangeMtrUnitFilter($contractChangeId: Long!, $where: FilterValueOfStringFilterInput) {
        uerContractChangeMtrUnitFilter(contractChangeId: $contractChangeId, where: $where) {
            items {
                value
            }
        }
    }
`);

export const getAgreementMtrSupplyByFilterItems = graphql(`
    query uerContractChangeMtrSupplyByFilter($contractChangeId: Long!) {
        uerContractChangeMtrSupplyByFilter(contractChangeId: $contractChangeId) {
            items {
                value
            }
        }
    }
`);

export const getAgreementMtrStatusFilterItems = graphql(`
    query uerContractChangeMtrStatusFilter($contractChangeId: Long!) {
        uerContractChangeMtrStatusFilter(contractChangeId: $contractChangeId) {
            items {
                value
            }
        }
    }
`);

export const getAgreementMtrJustificationFilterItems = graphql(`
    query uerContractChangeMtrJustificationFilter($contractChangeId: Long!, $where: FilterValueOfStringFilterInput) {
        uerContractChangeMtrJustificationFilter(contractChangeId: $contractChangeId, where: $where) {
            items {
                value
            }
        }
    }
`);

export const getAgreementPriceListUer = graphql(`
    query uerContractChangePriceListUer(
        $skip: Int
        $take: Int
        $contractChangeId: Long!
        $where: PriceListUerRowDataFilterInput
    ) {
        uerContractChangePriceListUer(skip: $skip, take: $take, contractChangeId: $contractChangeId, where: $where) {
            items {
                basePrice {
                    ozp
                    emm
                    zpm
                    mtr
                    eqp
                    pir
                    trn
                    nr
                    sp
                }
                currentPrices {
                    id
                    constructionTypeId
                    constructionTypeName
                    constructionTypeRelationStatus
                    unitCostWithOther
                    ozp
                    emm
                    zpm
                    mtr
                    eqp
                    pir
                    trn
                    nr
                    sp
                    unitCost
                }
                isIncludedInWorkOrder
                isIncludedInWorkOrderChange
                isIncludedInAct
                workScopes {
                    id
                    number
                    description
                }
                id
                sectionId
                sectionName
                groupId
                groupCode
                groupName
                unit
                code
                name
                chapter
                uerClassifier
                status
                justification
                workKind {
                    workCode
                    workInSum
                    workName
                    workRatio
                    workUniqueId
                    workUnit
                }
            }
            totalCount
        }
    }
`);

export const addUerToContractChange = graphql(`
    mutation uerAddUersToContractChange($contractChangeId: Long!, $uerBaseRowIds: [Long!]!) {
        uerAddUersToContractChange(contractChangeId: $contractChangeId, uerBaseRowIds: $uerBaseRowIds) {
            data
            result
            message
            buttonText
            hasValidation
            hideValidation
            validation {
                property
                message
            }
        }
    }
`);

export const getAgreementUerForIncluding = graphql(`
    query uerPriceListUerForIncludingToContractChange(
        $contractChangeId: Long!
        $skip: Int
        $take: Int
        $where: PriceListUerRowDataFilterInput
    ) {
        uerPriceListUerForIncludingToContractChange(
            contractChangeId: $contractChangeId
            skip: $skip
            take: $take
            where: $where
        ) {
            items {
                basePrice {
                    ozp
                    emm
                    zpm
                    mtr
                    eqp
                    pir
                    trn
                    nr
                    sp
                }
                currentPrices {
                    id
                    constructionTypeId
                    constructionTypeName
                    unitCostWithOther
                    ozp
                    emm
                    zpm
                    mtr
                    eqp
                    pir
                    trn
                    nr
                    sp
                    unitCost
                }
                isIncludedInWorkOrder
                isIncludedInWorkOrderChange
                isIncludedInAct
                workScopes {
                    id
                    number
                    description
                }
                id
                sectionId
                sectionName
                groupId
                groupCode
                groupName
                unit
                code
                name
                chapter
                uerClassifier
                status
                justification
                linkStatus
            }
            totalCount
        }
    }
`);

export const getAgreementUerCodeFilterItems = graphql(`
    query uerContractChangeUerCodeFilter($contractChangeId: Long!, $where: FilterValueOfStringFilterInput) {
        uerContractChangeUerCodeFilter(contractChangeId: $contractChangeId, where: $where) {
            items {
                value
            }
        }
    }
`);

export const getAgreementUerAndWorkScopeNameFilterItems = graphql(`
    query uerContractChangeUerAndWorkScopeNameFilter(
        $contractChangeId: Long!
        $where: PriceListUerAndWorkScopeNameDataFilterInput
    ) {
        uerContractChangeUerAndWorkScopeNameFilter(contractChangeId: $contractChangeId, where: $where) {
            items {
                id
                name
                isUer
                isWorkScope
            }
        }
    }
`);

export const getAgreementUerTypeFilterItems = graphql(`
    query uerContractChangeUerTypeFilter($contractChangeId: Long!) {
        uerContractChangeUerTypeFilter(contractChangeId: $contractChangeId) {
            items {
                value
            }
        }
    }
`);

export const getAgreementUerChapterFilterItems = graphql(`
    query uerContractChangeUerChapterFilter($contractChangeId: Long!) {
        uerContractChangeUerChapterFilter(contractChangeId: $contractChangeId) {
            items {
                value
            }
        }
    }
`);

export const getAgreementUerStatusFilterItems = graphql(`
    query uerContractChangeUerStatusFilter($contractChangeId: Long!) {
        uerContractChangeUerStatusFilter(contractChangeId: $contractChangeId) {
            items {
                value
            }
        }
    }
`);

export const getAgreementUerJustificationFilterItems = graphql(`
    query uerContractChangeUerJustificationFilter($contractChangeId: Long!) {
        uerContractChangeUerJustificationFilter(contractChangeId: $contractChangeId) {
            items {
                value
            }
        }
    }
`);

export const exportContractChangeAnalyticsAsExcelGql = graphql(`
    query uerExportContractChangeAnalyticsAsExcel(
        $contractChangeId: Long!
        $contractChangeToCompareWithId: Long
        $priceListType: [PriceListTypeEnum!]!
    ) {
        uerExportContractChangeAnalyticsAsExcel(
            contractChangeId: $contractChangeId
            contractChangeToCompareWithId: $contractChangeToCompareWithId
            priceListType: $priceListType
        ) {
            data {
                name
                count
                size
                dataUrl
            }
            result
            message
            buttonText
            hasValidation
            hideValidation
            validation {
                property
                message
            }
        }
    }
`);

export const getAgreementPriceListRatio = graphql(`
    query uerContractChangePriceListRatioRows(
        $contractChangeId: Long!
        $order: [PriceListRatioCoefficientRowDataSortInput!]
        $skip: Int
        $take: Int
        $where: PriceListRatioCoefficientRowDataFilterInput
    ) {
        uerContractChangePriceListRatioRows(
            contractChangeId: $contractChangeId
            order: $order
            skip: $skip
            take: $take
            where: $where
        ) {
            items {
                code
                id
                isIncludedInAct
                isIncludedInWorkOrder
                isIncludedInWorkOrderChange
                justification
                kem
                kmat
                knr
                kozp
                ksp
                ktz
                ktzzpm
                status
                workConditions
            }
            totalCount
        }
    }
`);

export const uerRatioRowForIncludingToContractChangeGql = graphql(`
    query uerRatioRowForIncludingToContractChange(
        $contractChangeId: Long!
        $skip: Int
        $take: Int
        $where: ContractRatioRowDataFilterInput
    ) {
        uerRatioRowForIncludingToContractChange(
            contractChangeId: $contractChangeId
            where: $where
            skip: $skip
            take: $take
        ) {
            items {
                id
                code
                number
                workConditions
                justification
                status
                ratioType
                groupId
                groupName
                groupIsArtificial
                kem
                kmat
                ktz
                ktzzpm
                kozp
                knr
                ksp
                isIncludedInWorkOrderChange
                isIncludedInWorkOrder
                isIncludedInAct
                isCustom
            }
            pageInfo {
                hasNextPage
                hasPreviousPage
            }
            totalCount
        }
    }
`);

export const getAgreementRatioForIncluding = graphql(`
    query uerPriceListRatioForIncludingToContractChange(
        $skip: Int
        $take: Int
        $contractChangeId: Long!
        $where: PriceListRatioRowDataFilterInput
    ) {
        uerPriceListRatioForIncludingToContractChange(
            skip: $skip
            take: $take
            contractChangeId: $contractChangeId
            where: $where
        ) {
            items {
                id
                appliesToId
                appliesToCode
                appliesToCodeName
                appliesToLinkStatus
            }
            totalCount
        }
    }
`);

export const addRatioToContractChange = graphql(`
    mutation uerAddRatiosToContractChange($contractChangeId: Long!, $ratioRowIds: [Long!]!) {
        uerAddRatiosToContractChange(contractChangeId: $contractChangeId, ratioRowIds: $ratioRowIds) {
            data
            result
            result
            buttonText
            hasValidation
            message
            hideValidation
            validation {
                property
                message
            }
        }
    }
`);

export const getAgreementRatioWorkConditionsFilterItems = graphql(`
    query uerContractChangeRatioWorkConditionsFilter($contractChangeId: Long!, $where: FilterValueOfStringFilterInput) {
        uerContractChangeRatioWorkConditionsFilter(contractChangeId: $contractChangeId, where: $where) {
            items {
                value
            }
        }
    }
`);

export const getAgreementRatioWorkTypeFilterItems = graphql(`
    query uerContractChangeRatioWorkTypeFilter($contractChangeId: Long!) {
        uerContractChangeRatioWorkTypeFilter(contractChangeId: $contractChangeId) {
            items {
                value
            }
        }
    }
`);

export const getAgreementRatioStatusFilterItems = graphql(`
    query uerContractChangeRatioStatusFilter($contractChangeId: Long!) {
        uerContractChangeRatioStatusFilter(contractChangeId: $contractChangeId) {
            items {
                value
            }
        }
    }
`);

export const removeUersFromContractChangeGql = graphql(`
    mutation uerRemoveUersFromContractChange($contractChangeId: Long!, $uerIds: [Long!]!) {
        uerRemoveUersFromContractChange(contractChangeId: $contractChangeId, uerIds: $uerIds) {
            data
            result
            message
            buttonText
            hasValidation
            hideValidation
            validation {
                property
                message
            }
        }
    }
`);

export const removeMtrsFromContractChangeGql = graphql(`
    mutation uerRemoveMtrsFromContractChange($contractChangeId: Long!, $mtrIds: [Long!]!) {
        uerRemoveMtrsFromContractChange(contractChangeId: $contractChangeId, mtrIds: $mtrIds) {
            data
            result
            message
            buttonText
            hasValidation
            hideValidation
            validation {
                property
                message
            }
        }
    }
`);

export const removeRatiosFromContractChangeGql = graphql(`
    mutation uerRemoveRatiosFromContractChange($contractChangeId: Long!, $ratioIds: [Long!]!) {
        uerRemoveRatiosFromContractChange(contractChangeId: $contractChangeId, ratioIds: $ratioIds) {
            data
            result
            message
            buttonText
            hasValidation
            hideValidation
            validation {
                property
                message
            }
        }
    }
`);

export const uerContractChangeUerForIncludingNameFilter = graphql(`
    query uerContractChangeUerForIncludingNameFilter($contractChangeId: Long!, $where: FilterValueOfStringFilterInput) {
        uerContractChangeUerForIncludingNameFilter(where: $where, contractChangeId: $contractChangeId) {
            items {
                value
            }
        }
    }
`);

export const getContractChangeUerForIncludingCodeFilter = graphql(`
    query uerContractChangeUerForIncludingCodeFilter($where: FilterValueOfStringFilterInput, $contractChangeId: Long!) {
        uerContractChangeUerForIncludingCodeFilter(where: $where, contractChangeId: $contractChangeId) {
            items {
                value
            }
        }
    }
`);

export const getContractChangeUerForIncludingLinkStatusFilter = graphql(`
    query uerContractChangeUerForIncludingLinkStatusFilter(
        $where: FilterValueOfPriceConstructionTypeRelationStatusEnumFilterInput
        $contractChangeId: Long!
    ) {
        uerContractChangeUerForIncludingLinkStatusFilter(where: $where, contractChangeId: $contractChangeId) {
            items {
                value
            }
        }
    }
`);

export const getContractChangeUerForIncludingStatusFilter = graphql(`
    query uerContractChangeUerForIncludingStatusFilter(
        $where: FilterValueOfUerRecordStatusEnumFilterInput
        $contractChangeId: Long!
    ) {
        uerContractChangeUerForIncludingStatusFilter(where: $where, contractChangeId: $contractChangeId) {
            items {
                value
            }
        }
    }
`);

export const getContractChangeUerForIncludingUnitFilter = graphql(`
    query uerContractChangeUerForIncludingUnitFilter($where: FilterValueOfStringFilterInput, $contractChangeId: Long!) {
        uerContractChangeUerForIncludingUnitFilter(where: $where, contractChangeId: $contractChangeId) {
            items {
                value
            }
        }
    }
`);

export const getContractChangeMtrForIncludingCodeFilter = graphql(`
    query uerContractChangeMtrForIncludingCodeFilter($contractChangeId: Long!, $where: FilterValueOfStringFilterInput) {
        uerContractChangeMtrForIncludingCodeFilter(contractChangeId: $contractChangeId, where: $where) {
            items {
                value
            }
        }
    }
`);

export const getContractChangeMtrForIncludingNameFilter = graphql(`
    query uerContractChangeMtrForIncludingNameFilter($contractChangeId: Long!, $where: FilterValueOfStringFilterInput) {
        uerContractChangeMtrForIncludingNameFilter(contractChangeId: $contractChangeId, where: $where) {
            items {
                value
            }
        }
    }
`);

export const getContractChangeMtrForIncludingUnitFilter = graphql(`
    query uerContractChangeMtrForIncludingUnitFilter($contractChangeId: Long!, $where: FilterValueOfStringFilterInput) {
        uerContractChangeMtrForIncludingUnitFilter(contractChangeId: $contractChangeId, where: $where) {
            items {
                value
            }
        }
    }
`);

export const getContractChangeRatioForIncludingCodeFilter = graphql(`
    query uerContractChangeRatioForIncludingCodeFilter(
        $contractChangeId: Long!
        $where: FilterValueOfStringFilterInput
    ) {
        uerContractChangeRatioForIncludingCodeFilter(contractChangeId: $contractChangeId, where: $where) {
            items {
                value
            }
        }
    }
`);

export const getContractChangeRatioForIncludingWorkConditionsFilter = graphql(`
    query uerContractChangeRatioForIncludingWorkConditionsFilter(
        $contractChangeId: Long!
        $where: FilterValueOfStringFilterInput
    ) {
        uerContractChangeRatioForIncludingWorkConditionsFilter(contractChangeId: $contractChangeId, where: $where) {
            items {
                value
            }
        }
    }
`);

export const getContractChangeRatioForIncludingStatusFilter = graphql(`
    query uerContractChangeRatioForIncludingStatusFilter(
        $contractChangeId: Long!
        $where: FilterValueOfRatioRecordStatusEnumFilterInput
    ) {
        uerContractChangeRatioForIncludingStatusFilter(contractChangeId: $contractChangeId, where: $where) {
            items {
                value
            }
        }
    }
`);

export const getContractChangeRatioSectionNameFilter = graphql(`
    query uerContractChangeRatioSectionNameFilter($contractChangeId: Long!, $where: FilterValueOfStringFilterInput) {
        uerContractChangeRatioSectionNameFilter(contractChangeId: $contractChangeId, where: $where) {
            items {
                value
            }
        }
    }
`);

export const getContractChangeUerSectionNameFilter = graphql(`
    query uerContractChangeUerSectionNameFilter($contractChangeId: Long!, $where: FilterValueOfStringFilterInput) {
        uerContractChangeUerSectionNameFilter(contractChangeId: $contractChangeId, where: $where) {
            items {
                value
            }
        }
    }
`);

export const getContractChangeUerGroupFullNameFilter = graphql(`
    query uerContractChangeUerGroupFullNameFilter($contractChangeId: Long!, $where: FilterValueOfStringFilterInput) {
        uerContractChangeUerGroupFullNameFilter(contractChangeId: $contractChangeId, where: $where) {
            items {
                value
            }
        }
    }
`);

export const getContractChangeUerWorkTypeNameFilter = graphql(`
    query uerContractChangeUerWorkTypeNameFilter($contractChangeId: Long!, $where: FilterValueOfStringFilterInput) {
        uerContractChangeUerWorkTypeNameFilter(contractChangeId: $contractChangeId, where: $where) {
            items {
                value
            }
        }
    }
`);

export const getContractChangeUerWorkTypeInSumFilter = graphql(`
    query uerContractChangeUerWorkTypeInSumFilter(
        $contractChangeId: Long!
        $where: FilterValueOfWorkInSumEnumFilterInput
    ) {
        uerContractChangeUerWorkTypeInSumFilter(contractChangeId: $contractChangeId, where: $where) {
            items {
                value
            }
        }
    }
`);

export const getContractChangeUerNameFilter = graphql(`
    query uerContractChangeUerNameFilter($contractChangeId: Long!, $where: FilterValueOfStringFilterInput) {
        uerContractChangeUerNameFilter(contractChangeId: $contractChangeId, where: $where) {
            items {
                value
            }
        }
    }
`);

export const getContractChangeRatioGroupFullNameFilter = graphql(`
    query uerContractChangeRatioGroupFullNameFilter($contractChangeId: Long!, $where: FilterValueOfStringFilterInput) {
        uerContractChangeRatioGroupFullNameFilter(contractChangeId: $contractChangeId, where: $where) {
            items {
                value
            }
        }
    }
`);

export const getContractChangeRatioAppliesToCodeNameFilter = graphql(`
    query uerContractChangeRatioAppliesToCodeNameFilter(
        $contractChangeId: Long!
        $where: FilterValueOfStringFilterInput
    ) {
        uerContractChangeRatioAppliesToCodeNameFilter(contractChangeId: $contractChangeId, where: $where) {
            items {
                value
            }
        }
    }
`);

export const getContractChangeRatioCodeFilter = graphql(`
    query uerContractChangeRatioCodeFilter($contractChangeId: Long!, $where: FilterValueOfStringFilterInput) {
        uerContractChangeRatioCodeFilter(contractChangeId: $contractChangeId, where: $where) {
            items {
                value
            }
        }
    }
`);

export const getContractChangeRatioAppliesToLinkStatusFilter = graphql(`
    query uerContractChangeRatioAppliesToLinkStatusFilter(
        $contractChangeId: Long!
        $where: FilterValueOfRatioRecordStatusEnumFilterInput
    ) {
        uerContractChangeRatioAppliesToLinkStatusFilter(contractChangeId: $contractChangeId, where: $where) {
            items {
                value
            }
        }
    }
`);

export const getContractChangeUerForIncludingSectionNameFilter = graphql(`
    query uerContractChangeUerForIncludingSectionNameFilter(
        $contractChangeId: Long!
        $where: FilterValueOfStringFilterInput
    ) {
        uerContractChangeUerForIncludingSectionNameFilter(contractChangeId: $contractChangeId, where: $where) {
            items {
                value
            }
        }
    }
`);

export const getContractChangeUerForIncludingGroupFullNameFilter = graphql(`
    query uerContractChangeUerForIncludingGroupFullNameFilter(
        $contractChangeId: Long!
        $where: FilterValueOfStringFilterInput
    ) {
        uerContractChangeUerForIncludingGroupFullNameFilter(contractChangeId: $contractChangeId, where: $where) {
            items {
                value
            }
        }
    }
`);

export const uerContractChangeOtherCostRows = graphql(`
    query uerContractChangeOtherCostRows(
        $skip: Int
        $take: Int
        $contractChangeId: Long!
        $where: ContractOtherCostItemDataFilterInput
        $order: [ContractOtherCostItemDataSortInput!]
    ) {
        uerContractChangeOtherCostRows(
            skip: $skip
            take: $take
            contractChangeId: $contractChangeId
            where: $where
            order: $order
        ) {
            items {
                canEdit
                canDelete
                isInUse
                calculatingType
                calculatingTypeValue
                catalogOtherCostType {
                    canDelete
                    id
                    isSystem
                    name
                    uniqueId
                }
                catalogOtherCostTypeId
                chapter
                constructionTypeId
                constructionTypeLimits {
                    constructionType {
                        code
                        id
                        name
                        shortName
                        catalogId
                        fullName
                        contractFileName
                        createdAt
                    }
                    relationStatus
                    seasonLimits {
                        constructionTypeId
                        cost
                        seasonId
                    }
                }
                contractId
                formula
                hasEmptyFormula
                hasEmptyOtherCostType
                id
                isEditable
                isGlobalOtherCost
                isIncludedInActKc2
                isIncludedInWorkOrder
                isIncludedInWorkOrderChange
                name
                rationale
                seasonLimits {
                    constructionTypeId
                    cost
                    seasonId
                }
                section
                status
            }
            pageInfo {
                hasNextPage
                hasPreviousPage
            }
            totalCount
        }
    }
`);

export const uerContractChangeOtherCostRowsForIncluding = graphql(`
    query uerContractChangeOtherCostRowsForIncluding(
        $skip: Int
        $take: Int
        $contractId: Long!
        $where: ContractOtherCostItemDataFilterInput
        $order: [ContractOtherCostItemDataSortInput!]
    ) {
        uerContractChangeOtherCostRowsForIncluding(
            skip: $skip
            take: $take
            contractId: $contractId
            where: $where
            order: $order
        ) {
            items {
                canDelete
                canEdit
                isInUse
                calculatingType
                calculatingTypeValue
                catalogOtherCostType {
                    canDelete
                    id
                    isSystem
                    name
                    uniqueId
                }
                catalogOtherCostTypeId
                chapter
                constructionTypeId
                constructionTypeLimits {
                    constructionType {
                        code
                        id
                        name
                        shortName
                        catalogId
                        fullName
                        contractFileName
                        createdAt
                    }
                    relationStatus
                    seasonLimits {
                        constructionTypeId
                        cost
                        seasonId
                    }
                }
                contractId
                formula
                hasEmptyFormula
                hasEmptyOtherCostType
                id
                isEditable
                isGlobalOtherCost
                isIncludedInActKc2
                isIncludedInWorkOrder
                isIncludedInWorkOrderChange
                name
                rationale
                seasonLimits {
                    constructionTypeId
                    cost
                    seasonId
                }
                section
                status
            }
            pageInfo {
                hasNextPage
                hasPreviousPage
            }
            totalCount
        }
    }
`);

export const uerAddOthersToContractChangeGql = graphql(`
    mutation uerAddOthersToContractChange($contractChangeId: Long!, $contractOtherCostIds: [Long!]!) {
        uerAddOthersToContractChange(contractChangeId: $contractChangeId, contractOtherCostIds: $contractOtherCostIds) {
            code
            buttonText
            code
            data
            hasValidation
            hideValidation
            message
            result
            validation {
                property
                message
            }
        }
    }
`);

export const uerRemoveOtherCostsFromContractChangeGql = graphql(`
    mutation uerRemoveOtherCostsFromContractChange($contractChangeId: Long!, $contractOtherCostIds: [Long!]!) {
        uerRemoveOtherCostsFromContractChange(
            contractChangeId: $contractChangeId
            contractOtherCostIds: $contractOtherCostIds
        ) {
            buttonText
            code
            data
            hasValidation
            hideValidation
            message
            result
            validation {
                property
                message
            }
        }
    }
`);

export const uerOthersForIncludingToContractChangeNameFilter = graphql(`
    query uerOthersForIncludingToContractChangeNameFilter(
        $skip: Int
        $take: Int
        $contractId: Long!
        $where: FilterValueOfStringFilterInput
        $order: [FilterValueOfStringSortInput!]
    ) {
        uerOthersForIncludingToContractChangeNameFilter(
            skip: $skip
            take: $take
            contractId: $contractId
            where: $where
            order: $order
        ) {
            items {
                value
            }
            pageInfo {
                hasNextPage
                hasPreviousPage
            }
            totalCount
        }
    }
`);

export const uerOthersForIncludingToContractChangeCalculatingTypeFilter = graphql(`
    query uerOthersForIncludingToContractChangeCalculatingTypeFilter(
        $skip: Int
        $take: Int
        $contractId: Long!
        $where: FilterValueOfOtherCostCalculationTypeEnumFilterInput
        $order: [FilterValueOfOtherCostCalculationTypeEnumSortInput!]
    ) {
        uerOthersForIncludingToContractChangeCalculatingTypeFilter(
            skip: $skip
            take: $take
            contractId: $contractId
            where: $where
            order: $order
        ) {
            items {
                value
            }
            pageInfo {
                hasNextPage
                hasPreviousPage
            }
            totalCount
        }
    }
`);
